import React, { Component, useState, useEffect } from "react";
import { FiDownload } from "react-icons/fi";
import styled from "styled-components";
import { useContext } from "react";
import ThemeContext from "../context/ThemeContext";
import classNames from "classnames";
import { FiInfo, FiX, FiCheck } from "react-icons/fi";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import moment from "moment";
import Shimmer from "react-shimmer-effect";
import { humanize } from "../components/common";
import CalendarShimmer from "./CalendarShimmer";
import ProfileShimmer from "./ProfileShimmer";
const SidebarWrapper = styled.div`
	min-width: 320px;
	width: 320px;
	overflow-y: scroll;
	padding: 0 32px 32px 0;
	background: #f9f9f9;
	transition: 0.2s all ease-in;

	@media (max-width: 786px) {
		width: 100%;
		padding: 0;
	}

	&::-webkit-scrollbar {
		width: 0px;
		background: transparent;
	}
`;
const Fraud = styled.div`
	width: 100%;
	padding: 0 11px;
	display: flex;
	flex-direction: column;
	/* align-items: center; */
	align-items: baseline;
	.exclamation {
		padding-top: 6px;
		font-size: larger;
	}
	P {
		font-weight: 400;
		margin: 0 0 0 5px;
		color: #3e3e3e;
	}
	color: ${(props) => (props.fraud == "0" ? "#24ca7a" : "red")};
	transition: 0.2s all ease-in;
	&::-webkit-scrollbar {
		width: 0px;
		background: transparent;
	}
`;

const DownloadButton = styled.div`
	font-size: 14px;
	font-weight: 700;
	background-color: ${(props) =>
		props.state == "loaded"
			? "#24ca7a"
			: props.state == "loading" || props.state == "downloading"
			? "#cecece"
			: ""};
	color: ${(props) =>
		props.state == "loaded"
			? "white"
			: props.state == "loading" || props.state == "downloading"
			? "#777777"
			: ""};
	border-radius: 2px;
	padding: 7px 20px;
	display: flex;
	align-items: center;
	width: fit-content;
	cursor: ${(props) =>
		props.state == "loaded" ? "pointer" : props.state == "loading" ? "default" : ""};
	/* margin: -14px 40px 14px 0; */
	&:hover {
		background-color: ${(props) =>
			props.state == "loaded"
				? "#139e66"
				: props.state == "loading" || props.state == "downloading"
				? "#cecece"
				: ""};
	}
`;

const SidebarContent = styled.div`
	/* margin-top: 50px; */
	color: ${(props) => props.theme.txt};
`;

const LinkButton = styled.div`
	font-weight: 400;
	transition: 0.2s all ease-in;
	color: #11a1f1;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
	&:nth-last-child(2) {
		color: #3e3e3e;
		&:hover {
			text-decoration: none;
			cursor: default;
		}
	}
`;
const FraudStatement = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	p {
		color: ${(props) => (props.cat === "behavioural" ? "#FFA000" : "#EB5353")};
	}
	.exclamation {
		padding: 2px;
		font-size: larger;
	}
`;
const AuthenticStatement = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	.exclamation {
		padding: 2px;
		font-size: larger;
	}
`;

const Profile = styled.div`
	background: ${(props) => props.theme.dull};
	padding: ${(props) => (props.errorState ? "32px 16px 0px 16px" : "16px 16px 16px 16px")};
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border: 1px solid #ececec;
`;
const Chip = styled.div`
  background: ${(props) => props.theme.dull};
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: 0.2s all ease-in;
  /* box-shadow: ${(props) =>
		props.isSelected ? "0 0 10px rgba(81, 203, 238, 1)" : "0 0 10px transparent"}; */
  /* border: ${(props) =>
		props.isSelected ? "1px solid rgba(81, 203, 238, 1)" : "1px solid transparent"}; */
  &:hover {
    box-shadow: ${(props) => !props.isSelected && "0 0 3px #fff"};
  }
`;
const ChipContainer = styled.div`
	display: flex;
	align-items: center;
`;
const Tags = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	font-size: 12px;
	width: 100%;
	margin: -5px 0 20px 0;
`;
const Section = styled.div`
	margin-top: 25px;
`;
const Header = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 10px;
`;
const HeaderText = styled.span`
	font-weight: 400;
	margin-right: 10px;
`;
const YearWrapper = styled.div`
	display: flex;
	margin-bottom: 15px;
`;
const MonthWrapper = styled.div`
	display: flex;
	font-size: 9px;
	flex-direction: column;
	flex: 1;
`;
const Pill = styled.div`
	border: 1px solid white;
	border-color: ${(props) => (props.isSelected ? props.theme.pill : props.theme.txt)};
	color: ${(props) =>
		props.theme.name === "dark" ? "white" : props.isSelected ? "white" : "#333"};
	border-radius: 12px;
	padding: 0px 6px;
	background: ${(props) => (props.isSelected ? props.theme.pill : "transparent")};
	margin: 0px 2px;
	margin-bottom: 4px;
	width: 15%;
	text-align: center;
`;
const tags = ["Salaried", "Running Loan"];
const firstRow = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
const secondRow = ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const renderYear = (obj, theme) => {
	return (
		<YearWrapper>
			<div style={{ marginRight: 10, fontSize: 12 }}>{obj.yr}</div>
			<MonthWrapper>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					{firstRow.map((r, i) => (
						<Pill theme={theme} isSelected={obj.mo.includes(i + 1)}>
							{r}
						</Pill>
					))}
				</div>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					{secondRow.map((r, i) => (
						<Pill theme={theme} isSelected={obj.mo.includes(i + 7)}>
							{r}
						</Pill>
					))}
				</div>
			</MonthWrapper>
		</YearWrapper>
	);
};
const initialize = (str) => {
	return str
		.toLowerCase()
		.replace("mr. ", "")
		.replace("ms. ", "")
		.replace("mrs. ", "")
		.replace("shri ", "")
		.split(" ")
		.slice(0, 2)
		.map((n) => n[0])
		.join("")
		.toUpperCase();
};
function timeTransform(init) {
	const result = {};
	init.forEach((elem) => {
		const [yr, month] = elem.split("-");
		if (yr in result) result[yr].push(parseInt(month));
		else result[yr] = [parseInt(month)];
	});
	return Object.entries(result).map((yrobj) => ({
		yr: yrobj[0],
		mo: yrobj[1],
	}));
}
const getBankIcon = (bank) => {
	return `https://finbox-cdn.s3.ap-south-1.amazonaws.com/bank_logos/${bank}.png`;
};
const getLatestBalance = (metrics) => {
	if (!metrics) return {};
	const toRet = {};
	metrics.metrics.account_wise_metrics.forEach((acc) => {
		const lastItem = acc.balance_ts[acc.balance_ts.length - 1];
		toRet[acc.account_id] = {
			latest: lastItem ? lastItem.balance : "",
			when: lastItem ? lastItem.date : "",
		};
	});
	return toRet;
};
const maskAccNum = (str) => {
	return str ? str.substring(str.length - 4, str.length) : "-";
};
export default (props) => {
	const { theme } = useContext(ThemeContext);
	const latestBalObj = getLatestBalance(props.metrics);
	const in_Name = props.identity
		? props.identity.identity.length > 0
			? props.identity.identity[0].name
			: null
		: null;

	let fraud1 =
		props.salary &&
		props.salary.fraud.fraud_type.reduce(function (allNames, obj) {
			let key = obj.fraud_type;
			if (!allNames[key]) {
				allNames[key] = [];
			}
			allNames[key].push(obj);

			return allNames;
		}, {});

	let fraudlist = {};
	let transac;
	props.salary &&
		props.transactions &&
		Object.keys(fraud1).forEach((key) => {
			if (
				!fraudlist[fraud1[key][0].fraud_category] &&
				props.transactions.transactions.some((row) =>
					fraud1[key].some((ele) => ele.transaction_hash == row.hash)
				)
			) {
				fraudlist[fraud1[key][0].fraud_category] = 1;
			} else fraudlist[fraud1[key][0].fraud_category]++;
		});

	return (
		<SidebarWrapper theme={theme}>
			<SidebarContent theme={theme}>
				<Profile theme={theme} errorState={props.errorState}>
					{!props.metrics ? (
						<ProfileShimmer />
					) : in_Name ? (
						<>
							{" "}
							<figure
								className="avatar avatar-xl"
								data-initial={initialize(in_Name)}
								style={{
									marginBottom: 20,
									backgroundColor: "#5755d9",
									minWidth: "3.2rem",
								}}
							></figure>
							<h4 style={{ textAlign: "center", fontSize: "1rem" }}>{in_Name}</h4>
							<p style={{ textAlign: "center", fontSize: 12 }}>
								{in_Name && props.identity.identity[0].address}
							</p>
							<Tags>
								{props.isSalaried && (
									<span
										className={classNames("label", "label-rounded", {
											"label-secondary": theme.name === "dark",
										})}
									>
										Salaried
									</span>
								)}
								{props.isLoaned && (
									<span
										className={classNames("label", "label-rounded", {
											"label-secondary": theme.name === "dark",
										})}
									>
										Running Loan
									</span>
								)}
							</Tags>
						</>
					) : (
						<div>Could not Extract User info</div>
					)}

					{props.metrics && (
						<DownloadButton
							onClick={() => {
								if (props.downloadState == "loaded") {
									props.downloadLink.map((object) => window.open(object.link, "_blank"));
									props.setDownloadState("loaded");
								}
							}}
							state={props.downloadState}
						>
							{props.downloadState == "downloading" ? (
								<>Downloading...</>
							) : props.downloadState == "loading" ? (
								<>Generating Report...</>
							) : props.downloadState == "loaded" ? (
								<>
									Download <FiDownload style={{ marginLeft: "10px" }} />
								</>
							) : (
								""
							)}
						</DownloadButton>
					)}
				</Profile>
				<Section>
					{!props.identity ? (
						<>
							<Header>
								<Shimmer>
									<div
										style={{
											height: "18px",
											borderRadius: "2px",
											width: "48px",
										}}
									/>
								</Shimmer>
							</Header>
							<Profile
								style={{
									background: "white",
									height: "58.8px",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<div
									style={{
										display: "flex",
										// padding: "15px",
										height: "fit-content",
										width: "100%",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<Shimmer>
										<div
											style={{
												width: "19px",
												height: "19px",
												borderRadius: "50%",
												// alignSelf: "center",
												marginRight: "5px",
												// borderRadius: "2px",
											}}
										/>
										<div
											style={{
												width: "140px",
												height: "20px",
												// alignSelf: "center",

												borderRadius: "2px",
											}}
										/>
									</Shimmer>
								</div>
							</Profile>
						</>
					) : (
						<>
							<Header>
								<HeaderText>Frauds</HeaderText>
							</Header>
							<Profile theme={theme}>
								{props.salary && (
									<Fraud fraud={props.salary.fraud.fraud_type.length}>
										{props.salary.fraud.fraud_type.length == "0" ? (
											<AuthenticStatement>
												<FaCheckCircle className="exclamation" />{" "}
												<p>Authentic Statement</p>
											</AuthenticStatement>
										) : (
											Object.keys(fraudlist).map((key, index) => {
												return (
													<FraudStatement
														cat={key}
														onClick={() => props.setActiveIndex(5)}
														style={{ cursor: "pointer" }}
													>
														<IoIosWarning
															className="exclamation"
															style={{
																color: key == "behavioural" ? "#FFA000" : "#EB5353",
															}}
														/>
														<p>{humanize(key)} Fraud</p>
														<p style={{ marginLeft: "auto" }}>({fraudlist[key]})</p>
													</FraudStatement>
												);
											})
										)}
									</Fraud>
								)}
							</Profile>
						</>
					)}
				</Section>

				<Section>
					{!props.identity ? (
						<CalendarShimmer />
					) : (
						<Header style={{ justifyContent: "space-between" }}>
							<HeaderText>Account</HeaderText>
							<LinkButton onClick={() => {props.showBankConnect(true);props.apiCall(true)}}>
								Add more statements
							</LinkButton>
						</Header>
					)}

					{props.identity &&
						props.identity.accounts.map((account, accountI) => {
							return (
								(
									<Chip
										style={{ border: "1px solid #ececec" }}
										theme={theme}
										isSelected={account.account_id === props.accountNum}
										onClick={() => props.setAccountNum(account.account_id)}
									>
										<ChipContainer style={{ marginBottom: "25px" }}>
											<figure className="avatar avatar-lg">
												<img
													src={getBankIcon(account.bank)}
													alt="..."
													style={{ background: "white" }}
												/>
											</figure>
											<div style={{ marginLeft: 20, flex: 1 }}>
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<div>{account.bank.toUpperCase()}</div>
													<div>
														<b>
															{latestBalObj[account.account_id] &&
																(account.bank == "ncb" || account.bank == "alrajhi"
																	? "SAR "
																	: "₹ ") +
																	parseInt(
																		latestBalObj[account.account_id].latest
																	).toLocaleString("en-IN")}
														</b>
													</div>
												</div>
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<div style={{ color: theme.faded }}>
														{maskAccNum(account.account_number)}
													</div>
													<div>
														{latestBalObj[account.account_id] && (
															<small style={{ color: theme.faded }}>
																{moment(
																	latestBalObj[account.account_id].when
																).format("DD MMM, YYYY")}
															</small>
														)}
													</div>
												</div>
											</div>
										</ChipContainer>

										{timeTransform(account.months).map((timeobj) =>
											renderYear(timeobj, theme)
										)}
									</Chip>
								)
							);
						})}
				</Section>
			</SidebarContent>
		</SidebarWrapper>
	);
};
